import { ReactNode } from 'react';
import Facebook from '@alltrails/denali/icons/Facebook';
import classNames from 'classnames';
import styles from './styles.module.scss';

type Props = {
  children: ReactNode;
  onClick: () => void;
  flatColors?: boolean;
};

const FacebookLoginButton = ({ children, onClick, flatColors = false }: Props) => {
  return (
    <button
      className={classNames(styles.button, { [styles.flatColors]: flatColors })}
      data-testid="facebookLoginButton"
      onClick={onClick}
      type="button"
    >
      <Facebook
        className={classNames(styles.icon, { [styles.flatColors]: flatColors })}
        color={flatColors ? 'currentColor' : '--color-neutral-white'}
      />
      {children}
    </button>
  );
};

export default FacebookLoginButton;
